import React from 'react';

// Central registry of official brand logos so a brand name is always shown
// as its original logo instead of typed text.
const LOGOS = {
  proofnation: { src: '/proofnation-logo.png', alt: 'ProofNation' },
  printfactory: { src: '/logos/printfactory.png', alt: 'PrintFactory' },
  barbieri: { src: '/logos/barbieri.png', alt: 'Barbieri' },
  nix: { src: '/logos/nix.png', alt: 'Nix Color Sensor' },
  impoproof: { src: '/logos/impoproof.png', alt: 'ImpoProof' },
};

// chip=true wraps the logo in a white rounded chip so dark-text logos stay
// legible on dark backgrounds.
const BrandLogo = ({
  brand,
  chip = false,
  className = '',
  imgClassName = 'h-8',
  chipClassName = 'px-3 py-2',
  testId,
}) => {
  const meta = LOGOS[brand];
  if (!meta) return null;

  const img = (
    <img
      src={meta.src}
      alt={meta.alt}
      data-testid={testId || `brand-logo-${brand}`}
      className={`object-contain ${imgClassName}`}
    />
  );

  if (chip) {
    return (
      <span className={`inline-flex items-center rounded-xl bg-white shadow-sm ${chipClassName} ${className}`}>
        {img}
      </span>
    );
  }

  return <span className={`inline-flex items-center ${className}`}>{img}</span>;
};

export const BRAND_LOGOS = LOGOS;
export default BrandLogo;
